// IT Assets addresses: /it-assets/<tab> for each tab, and /it-assets/<tab>/<id>
// for a record (an asset, a receipt or an event) opened over its tab, so any
// view can be linked to. Pure helpers; ItAssets.jsx reads and writes the URL.

export const TABS = [['assets', 'Assets'], ['available', 'Available'], ['loans', 'Loans'], ['events', 'Events'], ['receipts', 'Receipts'], ['locations', 'Locations'], ['people', 'People'], ['scan', 'Add / scan in']];
export const TAB_IDS = TABS.map(([id]) => id);

// Tabs whose rows open a record dialog, and that dialog's type.
const RECORD_TABS = { assets: 'asset', receipts: 'receipt', events: 'event' };
const RECORD_TAB = { asset: 'assets', receipt: 'receipts', event: 'events' };

export function parseRoute(tabParam, idParam) {
  const tab = TAB_IDS.includes(tabParam) ? tabParam : null;
  const record = tab && RECORD_TABS[tab] && /^\d+$/.test(idParam || '') ? { type: RECORD_TABS[tab], id: Number(idParam) } : null;
  return { tab, record };
}

export const tabPath = (tab) => `/it-assets/${tab}`;

// d is an openDialog request: { type: 'asset' | 'receipt', id } or { type: 'event', event }.
export const recordPath = (d) => `/it-assets/${RECORD_TAB[d.type]}/${d.type === 'event' ? d.event.id : d.id}`;
